import { getService } from 'data/function';
export class TranslateProcessor {
    static get TranslateService() {
        return getService('TranslateService');
    }
    static async process({ trackingProperties, source }) {
        const messageResponse = {
            response: TranslateProcessor.TranslateService.getCurrentLanguage(),
            trackingProperties,
        };
        source.postMessage(messageResponse, '*');
    }
}
